import { configureStore } from "@reduxjs/toolkit";

import DashboardSlice from "./dashboard.slice";
import ExchangeSwitcherSlice from "./exchange-switcher.slice";
import NotificationsSlice from "./notifications.slice";
import SidebarReducer from "./sidebar.slice";
import smartAllocationSlice from "./smart-allocation.slice";
import syncSlice from "./sync.slice";
import tradeSlice from "./trade.slice";
import UserSlice from "./user.slice";

export const store = configureStore({
  reducer: {
    sidebar: SidebarReducer,
    exchangeSwitcher: ExchangeSwitcherSlice,
    dashboard: DashboardSlice,
    notifications: NotificationsSlice,
    user: UserSlice,
    smartAllocation: smartAllocationSlice,
    sync: syncSlice,
    trade: tradeSlice,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
